import { render, staticRenderFns } from "./TaskCommentTreeNode.vue?vue&type=template&id=4dd173f6&"
import script from "./TaskCommentTreeNode.vue?vue&type=script&lang=js&"
export * from "./TaskCommentTreeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports